import React from "react";

const Blog = () => {
  return (
    <section className="my-10">
      <h1 className="text-cyan-500 text-xl text-center">Coming Soon</h1>
    </section>
  );
};

export default Blog;
